import { render, staticRenderFns } from "./FormUploadFbLeads.vue?vue&type=template&id=ff2d404a"
import script from "./FormUploadFbLeads.vue?vue&type=script&lang=js"
export * from "./FormUploadFbLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports